import React from 'react';
import { IconUiClose } from 'moods-react/Icons';

import './SpeechBubble.scss';

// TODO: replace this component with the speech bubble in MOODS stylesheets as soon as that's merged.

type Props = {
  title: string,
  body: string,
  callout: string,
  onClose: Function,
};

const SpeechBubbleComponent = (props: Props) => {
  const { title, body, callout, onClose } = props;
  return (
    <div className="speech-bubble-component">
      <div className="speech-bubble-component__arrow arrow" />
      <div className="speech-bubble-component__close" onClick={() => onClose()}>
        <IconUiClose />
      </div>
      <div className="speech-bubble-component__content">
        <div className="speech-bubble-component__title">
          <span className="speech-bubble-component__text">{title}</span>
          <span className="speech-bubble-component__label">{callout}</span>
        </div>
        <div className="speech-bubble-component__body">{body}</div>
      </div>
    </div>
  );
};

export default SpeechBubbleComponent;
